import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { lazy } from 'react'

const ReactQueryDevtools = import.meta.env.DEV
  ? lazy(() => import('@tanstack/react-query-devtools').then((m) => ({ default: m.ReactQueryDevtools })))
  : () => null
import { queryClient } from '@/lib/query-client'
import { initialiseTelemetry } from '@/services/telemetry'
import { initialiseFirebaseAnalytics } from '@/services/firebase/analytics'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import './index.css'
import App from './App.tsx'

// Open a session, install window-level error hooks, and start the perf
// flush timer BEFORE the first render. Cold-start time is captured from
// performance.timing.navigationStart so a slow boot still shows up
// correctly even though we call this after the bundle loads.
initialiseTelemetry()

// Boot Firebase Analytics + Performance Monitoring alongside the in-house
// telemetry. Fire-and-forget (async support check) and best-effort — a
// missing measurementId or unsupported browser degrades to no-op without
// touching app render.
void initialiseFirebaseAnalytics()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
)
